import React from 'react';
import {templateChoices} from './templateChoices';
import { Grid, Button } from '@material-ui/core'

export const TextTemplates = (props) => {
  const setAccordion = props.setAccordion
  const setMsg = props.setMsg

  return (
    <Grid container justifyContent="center">
      {templateChoices.map((template, index) => (
        <Button variant="contained" style={{marginBottom: '5px', width: '90%'}} onClick={() => {setMsg(template); setAccordion(false)}}>{template}</Button>
      ))}
    </Grid>
  )
}